var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fichar',{attrs:{"conIncidencia":true,"textButtonFichar":"Fichar con incidencia","bgColor":"lime darken-3"}})}
var staticRenderFns = []

export { render, staticRenderFns }